import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { Direction } from './button-slider-component.abstract';

@Injectable()
export class ButtonSliderService {
  change$ = new Subject<Direction>();

  changeDirection(direction: Direction): void {
    this.change$.next(direction);
  }
}
